import { render } from "./SocialGraph.vue?vue&type=template&id=72c5cef8&scoped=true&ts=true"
import script from "./SocialGraph.vue?vue&type=script&lang=ts"
export * from "./SocialGraph.vue?vue&type=script&lang=ts"

import "./SocialGraph.vue?vue&type=style&index=0&id=72c5cef8&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c5cef8"]])

export default __exports__